import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyDsFq3djtf-2MduWPES3KMp1jFEgASA_tU",
  authDomain: "playbook-app-98755.firebaseapp.com",
  projectId: "playbook-app-98755",
  storageBucket: "playbook-app-98755.appspot.com",
  messagingSenderId: "298710573026",
  appId: "1:298710573026:web:4ce1fd59b839d60b2ba3bb"
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);
export const googleProvider = new GoogleAuthProvider();
